import { createFileRoute } from "@tanstack/react-router"

// Import the existing explore page component
// This preserves 100% of business logic
import Explore from "@/features/jobs/explore/components/explore-page"

export const Route = createFileRoute("/_app/")({
  component: ExplorePage
})

function ExplorePage() {
  return <Explore />
}
